<template>
  <div>
    <v-container>
      <v-row>
        <v-col lg="12" class="pt-2 pb-1">
          <!-- TODO: Actualizar el servicio cuando esté disponible en el backend -->
          <s-crud
            title="Grupos de Mantenimiento TI (V2)"
            height="auto"
            searchInput
            add
            :rowDefault="false"
            @addEvent="openCreateGroupModal"
            ref="scrudMaintenanceGroup"
            sortable
            :config="configGroup"
            :filter="filterGroup"
          >
            <template v-slot:OverdueTasks="{ row }">
              <v-chip
                v-if="row.OverdueTasks > 0"
                small
                color="red lighten-5"
                text-color="red darken-4"
                class="font-weight-bold"
              >
                <v-icon left small>mdi-alert-circle</v-icon>
                {{ row.OverdueTasks }}
              </v-chip>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>

            <template v-slot:PendingTasks="{ row }">
              <v-chip
                v-if="row.PendingTasks > 0"
                small
                color="orange lighten-5"
                text-color="orange darken-4"
                class="font-weight-bold"
              >
                <v-icon left small>mdi-clock</v-icon>
                {{ row.PendingTasks }}
              </v-chip>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>

            <template v-slot:ReprogrammedTasks="{ row }">
              <v-chip
                v-if="row.ReprogrammedTasks > 0"
                small
                color="indigo lighten-5"
                text-color="indigo darken-4"
                class="font-weight-bold"
              >
                <v-icon left small>mdi-calendar-sync</v-icon>
                {{ row.ReprogrammedTasks }}
              </v-chip>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>

            <template v-slot:TotalTasks="{ row }">
              <v-chip
                v-if="row.TotalTasks > 0"
                small
                color="blue-grey lighten-5"
                text-color="blue-grey darken-4"
                class="font-weight-bold"
              >
                <v-icon left small>mdi-format-list-bulleted</v-icon>
                {{ row.TotalTasks }}
              </v-chip>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>
            <!-- Filtros -->
            <template v-slot:filter>
              <v-container>
                <v-row justify="center" class="s-col-form">
                  <v-col lg="3">
                    <s-date
                      label="Fecha Mantenimiento Inicio"
                      clearable
                      v-model="filterGroup.DateStart"
                    ></s-date>
                  </v-col>
                  <v-col lg="3">
                    <s-date
                      label="Fecha Mantenimiento Fin"
                      clearable
                      v-model="filterGroup.DateEnd"
                    ></s-date>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <!-- Acciones Personalizadas -->
            <template v-slot:actionsMainScrud="{ row }">
              <div style="display: flex; gap: 8px; padding: 6px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      color="primary"
                      @click="viewGroup(row)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Detalle</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      color="dark"
                      @click="editGroup(row)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Grupo</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      color="warning"
                      @click="openReprogramModal(row)"
                    >
                      <v-icon>mdi-calendar-sync</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Reprogramaciones</span>
                </v-tooltip>
              </div>
            </template>
          </s-crud>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal Principal de Creación / Edición -->
    <v-dialog
      v-model="dialogMain"
      max-width="1200"
      scrollable
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card class="bg-gray-50 rounded-xl">
        <!-- Toolbar Principal -->
        <s-toolbar
          color="primary"
          dark
          close
          @close="closeMainModal"
          :save="!isReadOnly"
          @save="saveGroup"
          :label="
            isReadOnly
              ? 'Ver Detalle del Grupo de Mantenimiento'
              : isEdit
              ? 'Editar Grupo de Mantenimiento'
              : 'Crear Grupo de Mantenimiento'
          "
          style="position: sticky; top: 0; z-index: 10"
        />

        <v-card-text
          class="pt-6 pb-6 px-4 px-md-8 bg-gray-50 custom-scrollbar"
          style="max-height: 85vh"
        >
          <!-- Paso 1: Rango de Fechas (Cabecera) -->
          <v-row>
            <v-col cols="12">
              <v-card
                outlined
                class="card-gradient pa-5 mb-4 rounded-xl shadow-md border-0"
              >
                <div class="d-flex align-center mb-4">
                  <v-avatar color="primary" size="36" class="mr-3">
                    <v-icon dark small>mdi-calendar-range</v-icon>
                  </v-avatar>
                  <div class="text-subtitle-1 font-weight-bold text-slate-800">
                    Definir Rango del Mantenimiento
                  </div>
                </div>
                <v-row :key="'dates-' + modalKey">
                  <v-col cols="12" md="4" lg="3">
                    <s-date
                      label="Fecha Inicio"
                      clearable
                      v-model="groupState.MaintenanceDateStart"
                      @input="generateTabs"
                      :disabled="isEdit || isReadOnly"
                    ></s-date>
                  </v-col>
                  <v-col cols="12" md="4" lg="3">
                    <s-date
                      label="Fecha Fin"
                      clearable
                      v-model="groupState.MaintenanceDateEnd"
                      @input="generateTabs"
                      :disabled="isEdit || isReadOnly"
                    ></s-date>
                  </v-col>
                  <v-col cols="12" md="4" lg="6">
                    <s-text
                      label="Descripción de la Programacion"
                      v-model="groupState.Description"
                      outlined
                      dense
                      hide-details
                      clearable
                      :disabled="isReadOnly"
                    ></s-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- Paso 2: Pestañas por Día y Asignaciones -->
          <v-row
            v-if="
              groupState.MaintenanceDateStart && groupState.MaintenanceDateEnd
            "
          >
            <v-col cols="12">
              <v-card
                outlined
                class="rounded-xl shadow-sm overflow-hidden bg-white border-0"
              >
                <v-tabs
                  v-model="activeTab"
                  background-color="transparent"
                  active-class="primary--text font-weight-bold tab-active"
                  color="primary"
                  show-arrows
                  class="custom-tabs"
                >
                  <v-tab
                    v-for="(day, index) in groupState.Days"
                    :key="index"
                    class="text-capitalize rounded-t-lg mx-1"
                  >
                    <v-icon left small>mdi-calendar-today</v-icon>
                    {{ formatDateLabel(day.MaintenanceDate) }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab" class="bg-gray-50 pa-4">
                  <v-tab-item
                    v-for="(day, index) in groupState.Days"
                    :key="index"
                  >
                    <div
                      class="d-flex justify-space-between align-center mb-6 mt-2"
                    >
                      <div>
                        <h3
                          class="text-h6 font-weight-bold text-slate-800 mb-0"
                        >
                          Panel de Tareas del Día
                        </h3>
                        <span class="text-caption text-slate-500"
                          >Programa los especialistas para el
                          {{ formatDateLabel(day.MaintenanceDate) }}</span
                        >
                      </div>
                      <v-btn
                        v-if="!isReadOnly"
                        color="primary"
                        rounded
                        elevation="2"
                        @click="addSupportCard(day)"
                        class="px-6"
                      >
                        <v-icon left>mdi-account-plus</v-icon>
                        Añadir Soporte
                      </v-btn>
                    </div>

                    <div
                      v-if="
                        day.TicEquipmentMaintenances.filter(
                          (m) => m.SecStatus !== 0,
                        ).length === 0
                      "
                      class="text-center pa-10 text-slate-500 border-dashed rounded-xl mb-4 bg-gray-50"
                      style="border: 2px dashed #cbd5e1"
                    >
                      <v-icon size="56" color="slate-400"
                        >mdi-clipboard-account-outline</v-icon
                      >
                      <div
                        class="text-h6 mt-4 font-weight-medium text-slate-700"
                      >
                        Sin especialistas programados
                      </div>
                      <div class="text-body-2 mt-2">
                        Haz clic en "Añadir Soporte" para iniciar la
                        distribución del trabajo de este día.
                      </div>
                    </div>

                    <!-- Lista de Tarjetas (Cada tarjeta es un TicEquipmentMaintenance) -->
                    <v-row v-else dense>
                      <template
                        v-for="(
                          maintenance, mIdx
                        ) in day.TicEquipmentMaintenances"
                      >
                        <v-col
                          cols="12"
                          xl="6"
                          v-if="maintenance.SecStatus !== 0"
                          :key="'m-' + mIdx"
                        >
                          <v-card
                            class="rounded-xl shadow-md mb-4 support-card overflow-hidden"
                            elevation="2"
                          >
                            <div class="support-header">
                              <div
                                class="font-weight-bold text-subtitle-1 d-flex align-center"
                              >
                                <v-icon left color="white"
                                  >mdi-account-hard-hat</v-icon
                                >
                                Especialista Asignado #{{ mIdx + 1 }}
                              </div>
                              <v-btn
                                v-if="!isReadOnly"
                                icon
                                small
                                dark
                                background-color="transparent"
                                @click="removeSupportCard(day, mIdx)"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>

                            <v-card-text class="pt-5 pb-5">
                              <v-row dense>
                                <v-col cols="12" md="6">
                                  <s-select
                                    label="Personal de Soporte"
                                    v-model="maintenance.NtpID"
                                    :items="supportsList"
                                    item-text="FullNameSoport"
                                    item-value="NtpID"
                                    :loading="loadingSupports"
                                    :disabled="isReadOnly"
                                  ></s-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <s-select-definition
                                    :def="1156"
                                    label="Mantenimiento"
                                    v-model="maintenance.TypeMaintenance"
                                    :disabled="isReadOnly"
                                  ></s-select-definition>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <s-select-definition
                                    :def="1530"
                                    label="Tipo (Equipo)"
                                    v-model="
                                      maintenance.TypeEquipmentMaintenance
                                    "
                                    :disabled="isReadOnly"
                                  ></s-select-definition>
                                </v-col>
                              </v-row>

                              <v-divider class="my-5"></v-divider>

                              <div
                                class="d-flex justify-space-between align-center mb-4 pb-1"
                              >
                                <span
                                  class="font-weight-bold text-slate-700 d-flex align-center"
                                >
                                  <v-icon left small color="slate-500"
                                    >mdi-laptop</v-icon
                                  >
                                  Equipos a intervenir
                                  <v-chip
                                    class="ml-2"
                                    x-small
                                    color="slate-200"
                                    text-color="slate-700"
                                  >
                                    {{
                                      maintenance.TicEquipmentMaintenanceDetails.filter(
                                        (d) => d.SecStatus !== 0,
                                      ).length
                                    }}
                                  </v-chip>
                                </span>
                                <v-btn
                                  v-if="!isReadOnly"
                                  small
                                  color="success"
                                  rounded
                                  depressed
                                  @click="openEquipmentSelector(maintenance)"
                                >
                                  <v-icon left small>mdi-plus-circle</v-icon>
                                  Buscar Equipos
                                </v-btn>
                              </div>

                              <div
                                v-if="
                                  maintenance.TicEquipmentMaintenanceDetails.filter(
                                    (d) => d.SecStatus !== 0,
                                  ).length === 0
                                "
                                class="text-center pa-6 bg-slate-50 rounded-lg text-slate-500 border-dashed-soft"
                              >
                                <v-icon color="slate-300" class="mb-2" size="32"
                                  >mdi-devices</v-icon
                                ><br />
                                Aún no has seleccionado equipos.
                              </div>
                              <div
                                v-else
                                class="d-flex flex-wrap gap-2 overflow-y-auto pr-2 custom-scrollbar"
                                style="max-height: 180px"
                              >
                                <template
                                  v-for="(
                                    detail, dIdx
                                  ) in maintenance.TicEquipmentMaintenanceDetails"
                                >
                                  <v-chip
                                    v-if="detail.SecStatus !== 0"
                                    :key="'d-' + dIdx"
                                    :close="!isReadOnly"
                                    @click:close="
                                      removeEquipment(maintenance, dIdx)
                                    "
                                    color="blue-grey lighten-5"
                                    text-color="blue-grey darken-3"
                                    class="font-weight-medium border-solid-light"
                                    small
                                  >
                                    <v-icon left small color="primary"
                                      >mdi-laptop</v-icon
                                    >
                                    {{ detail.CgeSerie || detail.CgeID }}
                                    <span
                                      v-if="detail.StatusMaintenanceName"
                                      class="ml-2 grey--text text--darken-2"
                                      style="font-size: 0.85em"
                                    >
                                      ({{ detail.StatusMaintenanceName }})
                                    </span>
                                  </v-chip>
                                </template>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </template>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal Catalogo Equipos -->
    <v-dialog v-model="dialogEquipments" max-width="1000" persistent>
      <v-card>
        <s-toolbar
          color="primary"
          dark
          close
          @close="dialogEquipments = false"
          label="Catálogo de Equipos"
        ></s-toolbar>
        <v-card-text class="pa-4 bg-gray-50">
          <div class="mb-4 d-flex justify-space-between align-center">
            <span class="text-subtitle-1 text-slate-700"
              >Seleccione los equipos para asignar al soporte.</span
            >
            <v-btn color="success" rounded @click="confirmEquipmentsSelection">
              <v-icon left>mdi-check</v-icon>
              Confirmar Selección ({{ equipmentsSelectedTmp.length }})
            </v-btn>
          </div>

          <v-card outlined class="rounded-xl overflow-hidden shadow-sm">
            <s-crud
              :key="equipmentCrudKey"
              title="Equipos TI Disponibles"
              searchInput
              :filter="filterEquipment"
              :single-row="false"
              ref="scrudEquipmentsV2"
              height="350px"
              :rowDefault="false"
              @rowSelected="getEquipmentsSelected"
              sortable
              :config="configEquipment"
            >
              <!-- Filtros -->
              <template v-slot:filter>
                <v-container>
                  <v-row justify="center" class="s-col-form">
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <s-select-definition
                        :def="1530"
                        label="Tipo Equipo"
                        v-model="filterEquipment.CgeTypeEquipment"
                        clearable
                        hide-details
                        disabled
                      />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <s-select-area
                        label="Área"
                        v-model="filterEquipment.AreID"
                        clearable
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <s-select-definition
                        :def="1541"
                        label="Estado"
                        v-model="filterEquipment.CgeStatus"
                        clearable
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:CgeStatusName="{ row }">
                <div
                  :class="{
                    'assigned-hide-marker': isEquipmentAlreadyAssigned(
                      row.CgeID,
                    ),
                  }"
                >
                  <v-chip
                    class="pl-2 pr-2"
                    small
                    :color="
                      row.CgeStatus === 1
                        ? 'success'
                        : row.CgeStatus == 2
                        ? 'yellow'
                        : [3, 4].includes(row.CgeStatus)
                        ? 'error'
                        : 'warning'
                    "
                  >
                    {{ row.CgeStatusName }}
                  </v-chip>
                </div>
              </template>
            </s-crud>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal Reprogramaciones -->
    <v-dialog v-model="dialogReprogram" max-width="1000" scrollable>
      <v-card class="bg-gray-50 rounded-xl">
        <s-toolbar
          color="primary"
          dark
          close
          @close="dialogReprogram = false"
          label="Reprogramaciones de Mantenimiento"
        ></s-toolbar>
        <v-card-text class="pa-6" style="max-height: 80vh">
          <v-row v-if="loadingReprogram" justify="center" class="my-10">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
          <div
            v-else-if="reprograms.length === 0"
            class="text-center pa-10 text-slate-500 border-dashed rounded-xl mb-4 bg-gray-50 bg-white"
            style="border: 2px dashed #cbd5e1"
          >
            <v-icon size="56" color="slate-400"
              >mdi-clipboard-text-off-outline</v-icon
            >
            <div class="text-h6 mt-4 font-weight-medium text-slate-700">
              No hay reprogramaciones
            </div>
            <div class="text-body-2 mt-2">
              Este grupo de mantenimiento no tiene solicitudes de
              reprogramación.
            </div>
          </div>
          <v-row v-else>
            <v-col cols="12" v-for="(item, idx) in reprograms" :key="idx">
              <v-card
                outlined
                class="rounded-lg shadow-md h-100 d-flex flex-column text-left mb-2"
                elevation="2"
                style="border: 1px solid #cbd5e1"
              >
                <!-- Header (Serie, Marca/Modelo, Estado) -->
                <v-card-title
                  class="d-flex justify-space-between align-center py-4 px-6"
                  style="
                    background: linear-gradient(
                      135deg,
                      #1e293b 0%,
                      #334155 100%
                    );
                    color: white;
                  "
                >
                  <div class="d-flex align-center" style="gap: 20px">
                    <v-icon color="white" x-large>mdi-laptop</v-icon>
                    <div>
                      <div
                        class="text-h6 font-weight-black mb-0"
                        style="letter-spacing: 1px; line-height: 1.2"
                      >
                        {{ item.CgeSerie || "SIN SERIE" }}
                      </div>
                      <div
                        class="text-subtitle-1 font-weight-medium"
                        style="opacity: 0.9"
                      >
                        {{ item.CgeBrandName || "Marca" }}
                        <span class="mx-2" style="opacity: 0.5">|</span>
                        {{ item.CgeModelName || "Modelo" }}
                      </div>
                    </div>
                  </div>
                </v-card-title>

                <!-- Cuerpo de Tarjeta -->
                <v-card-text class="pa-5 flex-grow-1 bg-white">
                  <v-row align="stretch" justify="space-between">
                    <!-- Sección de Fechas -->
                    <v-col
                      cols="12"
                      md="5"
                      class="d-flex flex-column justify-center pr-md-4"
                    >
                      <div
                        class="text-subtitle-2 font-weight-bold text-slate-800 mb-3"
                      >
                        Calendario de Mantenimiento
                      </div>
                      <v-row dense class="flex-grow-1">
                        <v-col cols="6">
                          <v-card
                            flat
                            class="pa-3 text-center rounded-lg h-100 d-flex flex-column justify-center"
                            style="
                              background-color: #f8fafc;
                              border: 1px solid #e2e8f0;
                            "
                          >
                            <div
                              class="text-caption text-uppercase font-weight-bold grey--text"
                            >
                              Original
                            </div>
                            <div
                              class="font-weight-bold mt-1 text-slate-800"
                              style="font-size: 1.1rem"
                            >
                              <v-icon small class="mr-1 pb-1"
                                >mdi-calendar-remove</v-icon
                              >
                              {{
                                item.PreviousScheduledDate
                                  ? $moment(item.PreviousScheduledDate).format(
                                      "DD/MM/YYYY",
                                    )
                                  : "---"
                              }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <v-card
                            flat
                            class="pa-3 text-center rounded-lg h-100 d-flex flex-column justify-center"
                            style="
                              background-color: #eff6ff;
                              border: 1px solid #bfdbfe;
                            "
                          >
                            <div
                              class="text-caption text-uppercase font-weight-bold primary--text"
                            >
                              Propuesta
                            </div>
                            <div
                              class="font-weight-bold mt-1 primary--text"
                              style="font-size: 1.1rem"
                            >
                              <v-icon small color="primary" class="mr-1 pb-1"
                                >mdi-calendar-check</v-icon
                              >
                              {{
                                item.ReprogrammedDate
                                  ? $moment(item.ReprogrammedDate).format(
                                      "DD/MM/YYYY",
                                    )
                                  : "---"
                              }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- Divisor para Escritorio -->
                    <v-divider
                      vertical
                      class="hidden-sm-and-down mx-2"
                    ></v-divider>
                    <v-divider class="hidden-md-and-up my-4"></v-divider>

                    <!-- Sección de Detalle -->
                    <v-col cols="12" md="6" class="d-flex flex-column pl-md-4">
                      <div class="mb-4">
                        <div
                          class="text-caption grey--text text-uppercase font-weight-bold mb-1"
                        >
                          Motivo Principal
                        </div>
                        <div
                          class="font-weight-bold text-slate-800"
                          style="font-size: 1.05rem"
                        >
                          {{
                            item.ReasonReprogramTypeName ||
                            item.ReasonReprogramType ||
                            "Motivo no especificado"
                          }}
                        </div>
                      </div>

                      <div
                        class="text-caption grey--text text-uppercase font-weight-bold mb-2"
                      >
                        Justificación del Especialista
                      </div>
                      <div
                        class="text-body-2 text-slate-700 pa-4 rounded-lg flex-grow-1"
                        style="
                          background-color: #f1f5f9;
                          border-left: 4px solid #cbd5e1;
                          font-size: 0.95rem;
                          line-height: 1.5;
                        "
                      >
                        "{{
                          item.ReasonReprogramDetail || "Sin detalle provisto."
                        }}"
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>

                <!-- BOTONES DE ACCIÓN -->
                <v-card-actions
                  v-if="Number(item.StatusReprogram) === 1"
                  class="pa-4 bg-gray-50 flex-wrap"
                  style="border-top: 1px solid #e2e8f0"
                >
                  <div class="text-caption grey--text font-weight-bold ml-2">
                    Esta acción actualizará el estatus general.
                  </div>
                  <v-spacer></v-spacer>
                  <div class="d-flex justify-end gap-2">
                    <v-btn
                      color="error"
                      outlined
                      @click="rejectReprogram(item)"
                      class="font-weight-bold mr-2"
                      large
                      style="border-width: 2px"
                    >
                      <v-icon left>mdi-close-circle</v-icon> RECHAZAR
                    </v-btn>
                    <v-btn
                      color="success"
                      elevation="2"
                      @click="approveReprogram(item)"
                      class="font-weight-bold px-6"
                      large
                    >
                      <v-icon left>mdi-check-circle</v-icon> APROBAR
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sEquipmentMaintenanceTI from "@/services/InformationTechnology/EquipmentMaintenanceService";
import _sTicEquipment from "@/services/InformationTechnology/EquipmentMaintenanceDetailService";
import _sAssignedEquipments from "@/services/InformationTechnology/EquipmentMaintenanceTasksService";

export default {
  data: () => ({
    filterGroup: { DateStart: null, DateEnd: null },
    dialogMain: false,
    dialogEquipments: false,
    isEdit: false,
    isReadOnly: false,
    activeTab: 0,
    modalKey: 0,
    equipmentCrudKey: 0,
    currentMaintenanceAddingEquipment: null,
    equipmentsSelectedTmp: [],

    supportsList: [],
    loadingSupports: false,

    dialogReprogram: false,
    reprograms: [],
    loadingReprogram: false,
    currentEmgIDForReprogram: null,

    // Estado principal
    groupState: {
      MaintenanceDateStart: null,
      MaintenanceDateEnd: null,
      Description: "",
      Days: [], // Arreglo enriquecido para la UI: contiene la fecha y la lista de mantenimientos (soportes)
    },

    // Configuración Base de Scrud de Grupos
    configGroup: {
      model: {
        EmgID: "ID",
        MaintenanceDateStart: "date",
        MaintenanceDateEnd: "date",
      },
      service: _sEquipmentMaintenanceTI,
      headers: [
        { text: "ID", value: "EmgID", width: 80 },
        { text: "Descripción", value: "Description", width: 300 },
        { text: "Inicio Rango", value: "MaintenanceDateStart" },
        { text: "Fin Rango", value: "MaintenanceDateEnd" },
        {
          text: "Tareas Vencidas",
          value: "OverdueTasks",
          align: "center",
          width: 100,
        },
        {
          text: "Tareas Pendientes",
          value: "PendingTasks",
          align: "center",
          width: 100,
        },
        {
          text: "Total de Reprogramaciones",
          value: "ReprogrammedTasks",
          width: 100,
          align: "center",
        },
        {
          text: "Total de tareas",
          value: "TotalTasks",
          align: "center",
          width: 100,
        },
        { text: "Acciones", value: "actionsMainScrud", width: 100 },
      ],
    },

    // Configuración base de Scrud de Equipos
    filterEquipment: { CgeTypeEquipment: null, AreID: null, CgeStatus: null },
    configEquipment: {
      model: { CgeID: "ID", CgeStatusName: "string" },
      service: _sTicEquipment,
      headers: [
        { text: "ID", value: "CgeID", width: 60, sortable: true },
        {
          text: "Nombre del Equipo",
          value: "CgeTypeEquipmentName",
          width: 120,
          sortable: true,
        },
        { text: "Serie", value: "CgeSerie", align: "center", sortable: true },
        { text: "Área", value: "AreName", align: "center", sortable: true },
        {
          text: "Estado",
          value: "CgeStatusName",
          width: 80,
          align: "center",
          sortable: true,
        },
      ],
    },
  }),
  methods: {
    async openReprogramModal(row) {
      this.currentEmgIDForReprogram = row.EmgID;
      this.dialogReprogram = true;
      await this.fetchReprograms();
    },
    async fetchReprograms() {
      if (!this.currentEmgIDForReprogram) return;
      this.loadingReprogram = true;
      try {
        const resp = await _sEquipmentMaintenanceTI.ReprogramList(
          this.currentEmgIDForReprogram,
          this.$fun.getUserID(),
        );
        if (resp && resp.status === 200) {
          this.reprograms = resp.data || [];
        } else {
          this.reprograms = [];
        }
      } catch (error) {
        this.$fun.alert("Error al obtener reprogramaciones.", "error");
        this.reprograms = [];
      } finally {
        this.loadingReprogram = false;
      }
    },
    async approveReprogram(item) {
      const confirm = await this.$fun.alert(
        "¿Está seguro de APROBAR esta reprogramación?",
        "question",
      );
      if (!confirm.value) return;

      const payload = {
        ...item,
        StatusReprogram: 2,
        UsrUpdateID: this.$fun.getUserID(),
      };

      try {
        const resp = await _sAssignedEquipments.saveReprogramMaintenance(
          payload,
          this.$fun.getUserID(),
        );
        if (resp && (resp.status === 200 || resp.data)) {
          this.$fun.alert("Reprogramación aprobada correctamente.", "success");
          await this.fetchReprograms();
          if (this.$refs.scrudMaintenanceGroup) {
            this.$refs.scrudMaintenanceGroup.refresh();
          }
        }
      } catch (error) {
        this.$fun.alert("Error al aprobar reprogramación.", "error");
      }
    },
    async rejectReprogram(item) {
      const confirm = await this.$fun.alert(
        "¿Está seguro de RECHAZAR esta reprogramación?",
        "question",
      );
      if (!confirm.value) return;

      const payload = {
        ...item,
        StatusReprogram: 3,
        UsrUpdateID: this.$fun.getUserID(),
      };

      try {
        const resp = await _sAssignedEquipments.saveReprogramMaintenance(
          payload,
          this.$fun.getUserID(),
        );
        if (resp && (resp.status === 200 || resp.data)) {
          this.$fun.alert("Reprogramación rechazada correctamente.", "success");
          await this.fetchReprograms();
        }
      } catch (error) {
        this.$fun.alert("Error al rechazar reprogramación.", "error");
      }
    },
    formatDateLabel(dateString) {
      if (!dateString) return "";
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    openCreateGroupModal() {
      this.isEdit = false;
      this.isReadOnly = false;
      this.modalKey += 1;
      this.resetGroupState();
      this.dialogMain = true;
      this.fetchSupports();
    },
    async fetchSupports() {
      if (this.supportsList.length > 0) return;
      try {
        this.loadingSupports = true;
        const resp = await _sEquipmentMaintenanceTI.listGetSupportStaff(
          { FullNameSoport: "" },
          this.$fun.getUserID(),
        );
        if (resp && resp.status === 200) {
          this.supportsList = resp.data || [];
        }
      } catch (error) {
        console.error("Error cargando soportes", error);
      } finally {
        this.loadingSupports = false;
      }
    },
    closeMainModal() {
      this.dialogMain = false;
      if (this.$refs.scrudMaintenanceGroup) {
        // Resetea la barra de herramientas del crud principal (oculta el botón guardar)
        if (
          this.$refs.scrudMaintenanceGroup.$refs &&
          this.$refs.scrudMaintenanceGroup.$refs.toolbar
        ) {
          this.$refs.scrudMaintenanceGroup.$refs.toolbar.showForm(false, false);
        }
      }
    },
    resetGroupState() {
      this.groupState = {
        EmgID: 0,
        MaintenanceDateStart: "",
        MaintenanceDateEnd: "",
        Description: "",
        Days: [],
      };
      this.activeTab = 0;
      this.generateTabs();
    },
    generateTabs() {
      if (
        !this.groupState.MaintenanceDateStart ||
        !this.groupState.MaintenanceDateEnd
      ) {
        this.groupState.Days = [];
        return;
      }

      // Convertir fechas YYYY-MM-DD
      const start = new Date(
        this.groupState.MaintenanceDateStart + "T00:00:00",
      );
      const end = new Date(this.groupState.MaintenanceDateEnd + "T00:00:00");

      if (start > end) {
        // Validación: Start > End
        this.groupState.Days = [];
        return;
      }

      const daysArray = [];
      let current = new Date(start);

      while (current <= end) {
        const yyyy = current.getFullYear();
        const mm = String(current.getMonth() + 1).padStart(2, "0");
        const dd = String(current.getDate()).padStart(2, "0");
        const dateStr = `${yyyy}-${mm}-${dd}`;

        // Buscamos si ya existía ese día para no borrar información si solo extienden el rango
        const existingDay = this.groupState.Days.find(
          (d) => d.MaintenanceDate === dateStr,
        );
        if (existingDay) {
          daysArray.push(existingDay);
        } else {
          daysArray.push({
            MaintenanceDate: dateStr,
            TicEquipmentMaintenances: [],
          });
        }

        current.setDate(current.getDate() + 1);
      }

      this.groupState.Days = daysArray;
    },
    addSupportCard(day) {
      day.TicEquipmentMaintenances.push({
        MaintenanceDate: day.MaintenanceDate,
        NtpID: null,
        TypeMaintenance: null,
        TypeEquipmentMaintenance: null,
        StatusMaintenanceGeneral: 1, // Por defecto Pendiente
        TemID: 0, // 0 = Inserción
        EmgID: this.groupState.EmgID || 0,
        TicEquipmentMaintenanceDetails: [],
      });
    },
    removeSupportCard(day, mIdx) {
      const m = day.TicEquipmentMaintenances[mIdx];
      if (m.TemID && m.TemID > 0) {
        m.SecStatus = 0;
        this.$set(day.TicEquipmentMaintenances, mIdx, m);
      } else {
        day.TicEquipmentMaintenances.splice(mIdx, 1);
      }
    },
    openEquipmentSelector(maintenance) {
      if (!maintenance.TypeEquipmentMaintenance) {
        alert("Debe seleccionar primero un Tipo de Equipo para poder filtrar.");
        return;
      }
      this.equipmentCrudKey += 1; // Resetea el estado interno del componente
      this.currentMaintenanceAddingEquipment = maintenance;
      this.equipmentsSelectedTmp = [];
      this.filterEquipment.CgeTypeEquipment =
        maintenance.TypeEquipmentMaintenance;
      this.dialogEquipments = true;
    },
    getAssignedEquipmentIds() {
      const ids = [];
      this.groupState.Days.forEach((d) => {
        d.TicEquipmentMaintenances.forEach((m) => {
          m.TicEquipmentMaintenanceDetails.forEach((det) => {
            ids.push(det.CgeID);
          });
        });
      });
      return ids;
    },
    isEquipmentAlreadyAssigned(id) {
      return this.getAssignedEquipmentIds().includes(id);
    },
    getEquipmentsSelected(items) {
      // Filtrar equipos con CgeStatus 5 (No seleccionables)
      const filtered = items.filter((x) => x.CgeStatus !== 5);
      this.equipmentsSelectedTmp = filtered;
    },
    confirmEquipmentsSelection() {
      const globalAssignedIds = this.getAssignedEquipmentIds();
      let rejectedCount = 0;

      if (this.currentMaintenanceAddingEquipment) {
        this.equipmentsSelectedTmp.forEach((eq) => {
          // Chequear si ya está asignado en cualquier lugar de este grupo
          if (!globalAssignedIds.includes(eq.CgeID)) {
            this.currentMaintenanceAddingEquipment.TicEquipmentMaintenanceDetails.push(
              {
                EmdID: 0, // 0 = Inserción
                TemID: this.currentMaintenanceAddingEquipment.TemID || 0,
                CgeID: eq.CgeID,
                CgeSerie: eq.CgeSerie, // Sólo mostrar UI
                StatusMaintenance: 1, // Pendiente
                StatusMaintenanceName: "Pendiente", // Sólo mostrar UI
              },
            );
            // Una vez añadido en este loop, lo agregamos artificialmente al array global
            // para que no se dupliquen dentro de la misma confirmación múltiple
            globalAssignedIds.push(eq.CgeID);
          } else {
            rejectedCount++;
          }
        });
      }

      if (rejectedCount > 0) {
        alert(
          `Se ignoraron ${rejectedCount} equipo(s) porque ya estaban asignados a un soporte diferente en este grupo.`,
        );
      }

      this.dialogEquipments = false;
      this.equipmentsSelectedTmp = [];
    },
    removeEquipment(maintenance, dIdx) {
      const detail = maintenance.TicEquipmentMaintenanceDetails[dIdx];
      if (detail.EmdID && detail.EmdID > 0) {
        detail.SecStatus = 0;
        this.$set(maintenance.TicEquipmentMaintenanceDetails, dIdx, detail);
      } else {
        maintenance.TicEquipmentMaintenanceDetails.splice(dIdx, 1);
      }
    },
    async saveGroup() {
      // Validaciones básicas de la cabecera
      if (
        !this.groupState.MaintenanceDateStart ||
        !this.groupState.MaintenanceDateEnd
      ) {
        this.$fun.alert(
          "Las fechas de inicio y fin son obligatorias.",
          "warning",
        );
        return;
      }
      if (
        !this.groupState.Description ||
        this.groupState.Description.trim() === ""
      ) {
        this.$fun.alert("El campo Descripción es obligatorio.", "warning");
        return;
      }

      const payload = {
        EmgID: this.groupState.EmgID || 0,
        MaintenanceDateStart:
          this.groupState.MaintenanceDateStart + "T00:00:00",
        MaintenanceDateEnd: this.groupState.MaintenanceDateEnd + "T00:00:00",
        Description: this.groupState.Description.trim(),
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
        SecCreate: new Date(),
        TicEquipmentMaintenances: [],
      };

      if (this.isEdit) {
        payload.UsrUpdateID = this.$fun.getUserID();
        payload.SecUpdate = new Date();
      }

      let isValid = true;
      let atLeastOneActiveSupport = false;

      // Armamos la lista y validamos la integridad
      this.groupState.Days.forEach((day) => {
        day.TicEquipmentMaintenances.forEach((m) => {
          // Si fue eliminado, no necesitamos validarlo, pero SÍ mandarlo
          if (m.SecStatus === 0) {
            payload.TicEquipmentMaintenances.push({
              TemID: m.TemID || 0,
              EmgID: this.groupState.EmgID || 0,
              NtpID: m.NtpID,
              TypeMaintenance: m.TypeMaintenance,
              TypeEquipmentMaintenance: m.TypeEquipmentMaintenance,
              MaintenanceDate: m.MaintenanceDate.includes("T")
                ? m.MaintenanceDate
                : m.MaintenanceDate + "T00:00:00",
              StatusMaintenanceGeneral: m.StatusMaintenanceGeneral,
              SecStatus: 0,
              UsrUpdateID: this.$fun.getUserID(),
              SecUpdate: new Date(),
              TicEquipmentMaintenanceDetails:
                m.TicEquipmentMaintenanceDetails.map((d) => ({
                  EmdID: d.EmdID || 0,
                  TemID: m.TemID || 0,
                  CgeID: d.CgeID,
                  StatusMaintenance: d.StatusMaintenance,
                  HasReportCreated: d.HasReportCreated ? 1 : 0,
                  ReleasedByManager: d.ReleasedByManager ? 1 : 0,
                  SecStatus: d.SecStatus ?? 0,
                  UsrUpdateID: this.$fun.getUserID(),
                  SecUpdate: null,
                })),
            });
            return;
          }

          atLeastOneActiveSupport = true;

          if (!m.NtpID || !m.TypeMaintenance || !m.TypeEquipmentMaintenance) {
            isValid = false;
          }

          payload.TicEquipmentMaintenances.push({
            TemID: m.TemID || 0,
            EmgID: this.groupState.EmgID || 0,
            NtpID: m.NtpID,
            TypeMaintenance: m.TypeMaintenance,
            TypeEquipmentMaintenance: m.TypeEquipmentMaintenance,
            MaintenanceDate: m.MaintenanceDate.includes("T")
              ? m.MaintenanceDate
              : m.MaintenanceDate + "T00:00:00",
            StatusMaintenanceGeneral: m.StatusMaintenanceGeneral,
            SecStatus: m.SecStatus ?? 1,
            UsrCreateID: this.$fun.getUserID(),
            SecCreate: new Date(),
            TicEquipmentMaintenanceDetails:
              m.TicEquipmentMaintenanceDetails.map((d) => ({
                EmdID: d.EmdID || 0,
                TemID: m.TemID || 0,
                CgeID: d.CgeID,
                StatusMaintenance: d.StatusMaintenance,
                HasReportCreated: d.HasReportCreated ? 1 : 0,
                ReleasedByManager: d.ReleasedByManager ? 1 : 0,
                SecStatus: d.SecStatus ?? 1,
                UsrCreateID: this.$fun.getUserID(),
                SecCreate: null,
              })),
          });
        });
      });

      if (!isValid) {
        this.$fun.alert(
          "Faltan datos obligatorios (Soporte, Tipo de Mant. o Tipo de Equipo) en una o más tarjetas creadas (no eliminadas).",
          "warning",
        );
        return;
      }

      if (!atLeastOneActiveSupport && !this.isEdit) {
        // Para registros nuevos, no podemos enviar 0 soportes activos
        this.$fun.alert(
          "Debe asignar al menos un especialista en mantenimiento.",
          "warning",
        );
        return;
      }

      // === DEBUG PAYLOAD LOG ===
      console.log(
        "=============== JSON ENVIADO A LA BD (saveGroup) ===============",
      );
      console.log(JSON.stringify(payload, null, 2));
      console.log(
        "================================================================",
      );

      try {
        const result = await _sEquipmentMaintenanceTI.save(
          payload,
          this.$fun.getUserID(),
        );
        if (result && (result.status === 200 || result.status === 201)) {
          this.$fun.alert(
            this.isEdit
              ? "Mantenimiento actualizado exitosamente."
              : "Mantenimiento registrado exitosamente.",
            "success",
          );
          this.dialogMain = false;
          if (this.$refs.scrudMaintenanceGroup) {
            this.$refs.scrudMaintenanceGroup.refresh();
          }
        } else {
          this.$fun.alert(
            result.Message ||
              "Ocurrió un problema guardando el mantenimiento, verifique.",
            "warning",
          );
        }
      } catch (error) {
        console.error("Error al guardar:", error);
        this.$fun.alert(
          error?.response?.data?.Message ||
            "Ocurrió un error en el servidor al guardar el mantenimiento.",
          "error",
        );
      }
    },
    parseScrudDate(val) {
      if (!val) return "";
      if (val.includes("/")) {
        const parts = val.split("/");
        if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return val.split(" ")[0].split("T")[0];
    },
    async viewGroup(row) {
      await this.editGroup(row);
      this.isReadOnly = true;
    },
    async editGroup(row) {
      if (!row || !row.MaintenanceDateStart || !row.MaintenanceDateEnd) {
        this.$fun.alert(
          "El registro seleccionado no tiene fechas válidas para editar.",
          "warning",
        );
        return;
      }

      this.isEdit = true;
      this.isReadOnly = false;
      this.modalKey += 1;
      this.resetGroupState();

      this.groupState.EmgID = row.EmgID;
      this.groupState.MaintenanceDateStart = this.parseScrudDate(
        row.MaintenanceDateStart,
      );
      this.groupState.MaintenanceDateEnd = this.parseScrudDate(
        row.MaintenanceDateEnd,
      );
      this.groupState.Description = row.Description || "";

      // Construye la base de las pestañas
      this.generateTabs();

      // Abrimos el modal y traemos soportes
      this.dialogMain = true;
      this.fetchSupports();

      try {
        const resp =
          await _sEquipmentMaintenanceTI.TicEquipmentMaintenanceGroupDetail(
            row.EmgID,
            this.$fun.getUserID(),
          );

        if (!resp || resp.status !== 200) {
          throw new Error("No se pudo obtener el detalle del mantenimiento.");
        }

        let baseData = resp.data;
        if (resp.data && resp.data.data) {
          baseData = resp.data.data;
        }

        const incomingData = Array.isArray(baseData) ? baseData : [baseData];

        incomingData.forEach((m) => {
          if (!m.MaintenanceDate) return;

          const dStr = m.MaintenanceDate.split("T")[0];
          let dayObj = this.groupState.Days.find(
            (d) => d.MaintenanceDate === dStr,
          );

          if (!dayObj) {
            dayObj = { MaintenanceDate: dStr, TicEquipmentMaintenances: [] };
            this.groupState.Days.push(dayObj);

            if (dStr < this.groupState.MaintenanceDateStart)
              this.groupState.MaintenanceDateStart = dStr;
            if (dStr > this.groupState.MaintenanceDateEnd)
              this.groupState.MaintenanceDateEnd = dStr;
          }

          dayObj.TicEquipmentMaintenances.push({
            TemID: m.TemID,
            MaintenanceDate: m.MaintenanceDate,
            NtpID: m.NtpID,
            TypeMaintenance: m.TypeMaintenance,
            TypeEquipmentMaintenance: m.TypeEquipmentMaintenance,
            StatusMaintenanceGeneral: m.StatusMaintenanceGeneral,
            SecStatus: m.SecStatus,
            EmgID: row.EmgID,
            TicEquipmentMaintenanceDetails: (
              m.DetalleMantenimiento ||
              m.TicEquipmentMaintenanceDetails ||
              []
            ).map((det) => ({
              EmdID: det.EmdID,
              TemID: m.TemID,
              CgeID: det.CgeID,
              CgeSerie: det.CgeSerie,
              StatusMaintenance: det.StatusMaintenance,
              StatusMaintenanceName: det.StatusMaintenanceName,
              SecStatus: det.SecStatus,
            })),
          });
        });

        // Re-ordenar pestañas cronológicamente en caso de inyecciones dinámicas
        this.groupState.Days.sort((a, b) =>
          a.MaintenanceDate.localeCompare(b.MaintenanceDate),
        );
      } catch (error) {
        console.error(
          "Error al obtener detalle del grupo de mantenimiento:",
          error,
        );
        this.$fun.alert(
          "Ocurrió un error al cargar el detalle del Mantenimiento.",
          "error",
        );
        this.dialogMain = false;
      }
    },
  },
};
</script>

<style scoped>
/* Oculta la fila completa si contiene el marcador de que ya está asignado */
::v-deep .v-data-table tbody tr:has(.assigned-hide-marker) {
  display: none !important;
}

/* Colores de fondo y utilidades */
.bg-gray-50 {
  background-color: #f8fafc;
}
.bg-gray-100 {
  background-color: #f1f5f9;
}
.bg-slate-50 {
  background-color: #f8fafc;
}
.text-slate-800 {
  color: #1e293b;
}
.text-slate-700 {
  color: #334155;
}
.text-slate-500 {
  color: #64748b;
}
.text-slate-400 {
  color: #94a3b8;
}

/* Sombras y bordes */
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.border-0 {
  border: none !important;
}
.border-dashed {
  border-style: dashed;
}
.border-dashed-soft {
  border: 2px dashed #e2e8f0;
}
.border-solid-light {
  border: 1px solid #cbd5e1;
}
.gap-2 {
  gap: 8px;
}

/* Cabeceras y Gradientes */
.card-gradient {
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0 !important;
}

.support-card {
  border: 1px solid #e2e8f0;
}

.support-header {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  padding: 12px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Estilos de Pestañas (Tabs) */
.custom-tabs {
  border-bottom: 1px solid #e2e8f0;
}
.tab-active {
  background-color: #eff6ff;
  border-top: 3px solid #3b82f6 !important;
}

/* Scrollbar Personalizado */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
